import React from 'react';
import {
  AboutContent,
  AboutDetailsContainer,
  AboutImage,
  AboutImageContainer,
  Resume,
  ResumeLink,
  StyledAbout,
} from '../styles/About.styled';
import { SectionHeading, SectionTitle } from '../styles/SectionHeading';
import { StyledParagraph } from '../styles/Typography.styled';
import myImage from '../../assets/about-image.jpg';
import downloadIcon from '../../assets/icons/download-icon.svg';
import resume from '../../assets/Vasanth.pdf';

const About = () => {
  return (
    <StyledAbout id="about">
      <SectionHeading dark="true" mb="3rem">
        <SectionTitle dark="true" number="02">
          About Me
        </SectionTitle>
      </SectionHeading>
      <AboutContent>
        <AboutImageContainer>
          <AboutImage src={myImage} />
        </AboutImageContainer>
        <AboutDetailsContainer>
          <StyledParagraph>
            I'm Vasanth Prabhakaran. I am an enthusiastic full-stack developer
            from India.
          </StyledParagraph>
          <StyledParagraph>
            I enjoy designing and developing responsive websites and web apps
            from the ground up. React, Vue, Angular, NextJS, NuxtJS, HTML, CSS,
            JavaScript, Typescript, TailwindCSS, Bootstrap, NodeJS, ASP.NET,
            Git, Figma, Jenkins, VS Code, and other technologies, tools, and
            languages are used to build my projects.
          </StyledParagraph>
          <StyledParagraph>
            Every day, I am keen on discovering something new, and I enjoy
            sharing my knowledge with my colleagues and developers. And I am
            excited to speak with you!
          </StyledParagraph>
          <Resume>
            <ResumeLink
              href={resume}
              icon={downloadIcon}
              download="vasanth-resume"
            >
              Download Resume
            </ResumeLink>
          </Resume>
        </AboutDetailsContainer>
      </AboutContent>
    </StyledAbout>
  );
};

export default About;
